import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import {
  selectedGatheringAtom,
  selectedGatheringAreaAtom,
  selectedGatheringItemAtom,
} from '@/atoms'
import { allRecords } from '@/data/gatheringIndex'
import { SKILL_TIERS } from '@/types/constants'
import type { GatherRecord } from '@/types'

export function useGatheringList(): GatherRecord[] {
  const gathering = useAtomValue(selectedGatheringAtom)
  const area = useAtomValue(selectedGatheringAreaAtom)
  const item = useAtomValue(selectedGatheringItemAtom)

  return useMemo(() => {
    const selectedTier = SKILL_TIERS.find(({ label }) => label === area)

    return allRecords.filter((r) => {
      if (r.gatheringType !== gathering) return false

      if (gathering === 'fishing') {
        if (selectedTier && r.tierIndex !== selectedTier.index) return false
        if (area && !selectedTier && r.area !== area) return false
        return !item || r.name === item
      }

      return (!area || r.area === area) && (!item || r.name === item)
    })
  }, [gathering, area, item])
}
